// Blank model
const model = {
  id: '',
  content: '',
  resource_id: '',
  resource_type: ''
}

export default {
  recommendations: [],
  active_recommendation: Object.create(model),
  is_submitting: false,
  is_deleting: false
}
